import * as React from "react";
import { ArrowCircleLeft24Regular } from "@fluentui/react-icons";
import { LargeTitle, makeStyles, ToolbarButton } from "@fluentui/react-components";
import { useNavigate, useParams } from "react-router-dom";
import { flexColumn, formStyle, fullSpace } from "../../styles/GlobalStyles";
import { articles } from "../articles/KnowledgeArticleIndex";
import { GenericToolbar } from "../../components/GenericToolbar";
import { CopyButton } from "../../components/CopyButton";

const useStyles = makeStyles({
    fullSpace: fullSpace,
    formRoot: {
        ...formStyle,
        height: "100%"
    },
    form: formStyle,
    flexColumn: flexColumn
});

export const KnowledgeArticleView: React.FC = React.memo(() => {
    const navigate = useNavigate();

    const styles = useStyles();
    const { id } = useParams();

    const article = React.useMemo(() => Object.values(articles).flat().find(a => a.id === id), [ id ]);

    return (
        <div id="articleRoot" className={styles.formRoot}>
            <GenericToolbar
                actionButtons={
                    <>
                        <ToolbarButton
                            aria-label="Back"
                            appearance="subtle"
                            icon={<ArrowCircleLeft24Regular />}
                            onClick={() => navigate(-1)}
                        />
                        <CopyButton title="Copy this article's url" value={window.location.href} />
                    </>
                }
            />
            <div className={styles.form}>
                <div className={styles.flexColumn}>
                    <LargeTitle>{article?.title}</LargeTitle>
                    { article?.component}
                </div>
            </div>
        </div>
    );    
});